import React from 'react';
import { Button } from '@mui/material';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import PreviewIcon from '@mui/icons-material/Preview';
import { deletePackingSlip } from '../../../Store/PHPSlice/Packing/PackApis';


const TableBody = ({
    serialNumber,
    id,
    firmNm,
    pkMemo,
    partyNm,
    transportNm,
    dt,
    totqty,
    sts,
    totamt,
    selected,
    dcsts,
    dcId,
    handleClick,
}) => {
    const dispatch = useDispatch();
    // const getDelete = useSelector((state) => state.companyData.deleteComp);
    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/packing-edit/${id}`, '_blank', 'width=1000,height=700,scrollbars=yes,resizable=yes');
    };
    const userId = '1';



    const handleDeleteClick = () => {
        // Show confirmation dialog


        const isConfirmed = window.confirm("Are you sure you want to delete Packing Slip?");

        // // If user confirms, proceed with deletion
        if (isConfirmed) {
            dispatch(deletePackingSlip(id))
                .then(() => {
            // Reload the page to show updated results
                    alert("Packing Slip Deleted");
                     window.location.reload();
                })
                 .catch((error) => {
                     // Handle any errors that occur during the deletion process
                     console.error("Error deleting Item:", error);
                     toast.error("Failed to delete Item");
                 });
        }
    };

    const handleFinalPrint = () => {
        window.open(`/packing-print/${id}`, '_blank', 'width=1000,height=700,scrollbars=yes,resizable=yes');
    }


    const handleViewClick = () => {
        window.open(`/packing-print/${id}`, '_blank', 'width=1000,height=700,scrollbars=yes,resizable=yes');
    };

    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {serialNumber}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {firmNm}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {pkMemo}
                </TableCell>


                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {partyNm}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {transportNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {dt}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {totqty}
                </TableCell>
                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {totamt}
                </TableCell> */}

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <h4 onClick={handleFinalPrint} style={{ color: '#4d79ff', cursor: 'pointer' }}>Print</h4>
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
    <Button
        variant="contained"
        size="small"
        onClick={handleFinalPrint}
        sx={{
            backgroundColor: dcsts == 0 ? '#ff4d4f' : '#52c41a',
            '&:hover': {
                backgroundColor: dcsts == 0 ? '#d9363e' : '#389e0d'
            }
        }}
    >
        {dcsts == 0 ? "Pending" : "Updated"}
    </Button>
</TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <EditIcon className={`cursor-pointer ${sts === '1' && dcsts=='1' ? 'disabled-icon' : ''}`} onClick={handleEditClick} />
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <PreviewIcon onClick={handleViewClick} className='cursor-pointer' />
                </TableCell>

                
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <DeleteIcon className={`cursor-pointer ${sts === '1' && dcsts=='1' ? 'disabled-icon' : ''}`} onClick={handleDeleteClick} />
                </TableCell> 


            </TableRow>
        </>
    );
};

export default React.memo(TableBody);
